<template>
  <section class="d-flex align-items-center" id="wrap">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 text-center">
          <h1 class="circle">3</h1>
          <h2>RETRIEVED DATA FROM THE ID CARD</h2>
        </div>
        <div class="col-12" id="cedula">
          <div id="foto"><img :src="'data:image/png;base64,'+data.image" alt=""></div>
          <div id="datos">
            <p>{{data.nationalRegistrationNumber}}</p>
            <p>{{data.lastName}}</p>
            <p>{{data.givenName}}</p>
            <p>{{data.dateOfBirth}}</p>
            <p>{{data.nationality}}</p>
            <p>{{data.docNumber}}</p>
            <p>{{data.expirationDate}}</p>
          </div>
        </div>
        <div class="col-12" id="button-ok-final">
          <a class="btn btn-comenzar" href="#" @click="toIndex">BACK</a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "StepTwo",
  props:{
    data: {}
  },methods: {
    toIndex(){
      this.$emit('nextStep','MainContent');
    }
  },emits: ['nextStep'],
}
</script>

<style scoped>

</style>